import Profile from "../dashboard/Profile";

const Settings = () => {
  return <Profile />;
};

export default Settings;
